import { format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

export function formatDateTime(
  iso: string | null | undefined,
  tz?: string,
): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  if (tz) {
    return formatInTimeZone(d, tz, "yyyy-MM-dd HH:mm zzz");
  }
  return format(d, "yyyy-MM-dd HH:mm");
}

export function formatDate(
  iso: string | null | undefined,
  tz?: string,
): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  if (tz) return formatInTimeZone(d, tz, "yyyy-MM-dd");
  return format(d, "yyyy-MM-dd");
}

export function formatPpm(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  if (value >= 100) return `${value.toFixed(0)} ppm`;
  if (value >= 10) return `${value.toFixed(1)} ppm`;
  return `${value.toFixed(2)} ppm`;
}

export function formatMinutes(minutes: number | null | undefined): string {
  if (minutes === null || minutes === undefined) return "—";
  if (minutes < 60) return `${minutes} min`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}h ${m}m`;
}

export function formatInteger(value: number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  return new Intl.NumberFormat("en-CA").format(value);
}

/**
 * Coerce a possibly-string / empty / null API value to a finite number, or null.
 * The one parser shared by the carcinogen comparators (src/lib/carcinogen.ts) and
 * the per-incident exposure table, so the two never drift on how a numeric field
 * (the API serves decimals as strings) is read.
 */
export function toNum(v: string | number | null | undefined): number | null {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}
